import { useQuery, useQueryClient } from '@tanstack/react-query';

import { RestaurantEmployee, useRestaurantsService } from '@restworld/data-services';

import { useEmployerRestaurantDetails } from './use-employer-restuarant-details';

export const useRestaurantTeamMatesQuery = () => {
  const restaurantService = useRestaurantsService();
  const queryKey = useQueryKey();
  useQuery({
    queryKey: queryKey,
    queryFn: async () => (await restaurantService.fetchRestaurantEmployees(queryKey[1])).data?.data,
    enabled: !!queryKey[1],
  });
};
const useQueryKey = () => {
  const employerRestaurantDetails = useEmployerRestaurantDetails();
  const restaurantId = employerRestaurantDetails?.id;
  return ['restaurantEmployees', restaurantId];
};
export const useRestaurantTeamMates = () => {
  const queryKey = useQueryKey();
  const restaurantEmployees = useQueryClient().getQueryData<RestaurantEmployee[]>(queryKey);
  return restaurantEmployees;
};
